import { EContentPanelRoute, IContentFilterBlock } from 'lingo2-models';
import { Subject as BaseSubject } from 'lingo2-models/dist/content/subject';

export const customPagesForMyClasses: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: EContentPanelRoute['my-classes/dashboard'],
    type: 'subject',
    title: 'my-classes/dashboard.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['my-classes/events'],
    type: 'subject',
    title: 'my-classes/events.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 1,
    id: 1,
    code: EContentPanelRoute['my-classes/classrooms'],
    type: 'subject',
    title: 'my-classes/classrooms.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 3,
    id: 3,
    code: EContentPanelRoute['my-classes/homework'],
    type: 'subject',
    title: 'my-classes/homework.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['my-classes/tutors'],
    type: 'subject',
    title: 'my-classes/tutors.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
];

export const customPagesForMyClassesForTutors: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: EContentPanelRoute['my-classes/dashboard'],
    type: 'subject',
    title: 'my-classes/dashboard.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 1,
    id: 1,
    code: EContentPanelRoute['my-classes/classrooms'],
    type: 'subject',
    title: 'my-classes/classrooms.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['my-classes/events'],
    type: 'subject',
    title: 'my-classes/events.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 3,
    id: 3,
    code: EContentPanelRoute['my-classes/homework'],
    type: 'subject',
    title: 'my-classes/homework.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 4,
    id: 4,
    code: EContentPanelRoute['my-classes/tutors'],
    type: 'subject',
    title: 'my-classes/tutors.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 5,
    id: 5,
    code: EContentPanelRoute['my-classes/students'],
    type: 'subject',
    title: 'my-classes/students.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 6,
    id: 6,
    code: EContentPanelRoute['my-classes/schools'],
    type: 'subject',
    title: 'my-classes/schools.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
];

export const customPagesForMyLibrary: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: EContentPanelRoute['my-library/lessons'],
    type: 'subject',
    title: 'my-library/lessons.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['my-library/collections'],
    type: 'subject',
    title: 'my-library/collections.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
];

export const customPagesForMyLibraryForTutors: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: EContentPanelRoute['my-library/lessons'],
    type: 'subject',
    title: 'my-library/lessons.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 1,
    id: 1,
    code: EContentPanelRoute['my-library/services'],
    type: 'subject',
    title: 'my-library/services.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['my-library/collections'],
    type: 'subject',
    title: 'my-library/collections.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
    is_visible: true,
  },
  // {
  //   order: 3,
  //   id: 3,
  //   code: 'my-library/courses',
  //   type: 'subject',
  //   title: 'my-library/courses.page-header-title',
  //   item: new BaseSubject(),
  //   total_count: 0,
  // },
];

export const customPagesForFavorites: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: EContentPanelRoute['favorites/lessons'],
    type: 'subject',
    title: 'favorites/lessons.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 1,
    id: 1,
    code: EContentPanelRoute['favorites/services'],
    type: 'subject',
    title: 'favorites/services.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 2,
    id: 2,
    code: EContentPanelRoute['favorites/tutors'],
    type: 'subject',
    title: 'favorites/tutors.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 3,
    id: 3,
    code: EContentPanelRoute['favorites/collections'],
    type: 'subject',
    title: 'favorites/collections.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 4,
    id: 4,
    code: EContentPanelRoute['favorites/users'],
    type: 'subject',
    title: 'favorites/users.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 5,
    id: 5,
    code: EContentPanelRoute['favorites/schools'],
    type: 'subject',
    title: 'favorites/schools.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
];

export const customPagesForFeed: IContentFilterBlock[] = [
  {
    order: 0,
    id: 0,
    code: 'my-feed/feed',
    type: 'subject',
    title: 'my-feed/feed.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 1,
    id: 1,
    code: 'my-feed/publications',
    type: 'subject',
    title: 'my-feed/publications.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 2,
    id: 2,
    code: 'my-feed/lessons',
    type: 'subject',
    title: 'my-feed/lessons.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 3,
    id: 3,
    code: 'my-feed/collections',
    type: 'subject',
    title: 'my-feed/collections.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 4,
    id: 4,
    code: 'my-feed/classes',
    type: 'subject',
    title: 'my-feed/classes.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 5,
    id: 5,
    code: 'my-feed/reviews',
    type: 'subject',
    title: 'my-feed/reviews.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 6,
    id: 6,
    code: 'my-feed/comments',
    type: 'subject',
    title: 'my-feed/comments.page-header-title',
    item: new BaseSubject(),
    total_count: 0,
  },
];
